"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Body_1 = __importDefault(require("../body/Body"));
var React = __importStar(require("react"));
var react_feather_1 = require("react-feather");
var Styled = __importStar(require("./FaqSectionStyles"));
var FaqSection = function (_a) {
    var question = _a.question, answer = _a.answer;
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var wrapperRef = React.useRef(null);
    React.useEffect(function () {
        var handleClickOutside = function (event) {
            var _a;
            if (wrapperRef.current && !((_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)))
                setOpen(false);
        };
        document.addEventListener('click', handleClickOutside, true);
        return function () {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
    return (React.createElement(Styled.Container, { ref: wrapperRef, open: open },
        React.createElement(Styled.QuestionContainer, { onClick: function () { return setOpen(!open); } },
            React.createElement(Body_1.default, { withoutMargins: true }, question),
            open ? React.createElement(react_feather_1.ChevronUp, { size: 16 }) : React.createElement(react_feather_1.ChevronDown, { size: 16 })),
        open && (React.createElement(Styled.AnswerContainer, null,
            React.createElement(Body_1.default, { withoutMargins: true }, answer)))));
};
exports.default = FaqSection;
